import React from "react";
import { Title } from "../../atoms";
import T from "prop-types";

export const MultilineTitle = ({
  upperText,
  bottomText,
  onClick,
  upperClsName,
  bottomClsName,
  boxClsName,
}) => {
  return (
    <div className={`multiSec ${boxClsName}`}>
      <Title className={upperClsName} text={upperText} />
      <Title className={bottomClsName} text={bottomText} onClick={onClick} />
    </div>
  );
};

MultilineTitle.T = {
  upperText: T.string,
  bottomText: T.string,
};
MultilineTitle.defaultProps = {
  upperClsName: "upperCls",
  bottomClsName: "bottomCls",
};
